<script setup lang="ts">
import SessionProgressHeader from '@/components/session/SessionProgressHeader.vue';
import ButtonPanel from '@/components/session/ui/ButtonPanel.vue';
import Loading from '@/components/ui/Loading.vue';
</script>

<template>
  <div class="flex h-dvh flex-col items-center sm:block">
    <header class="w-full flex-shrink-0">
      <SessionProgressHeader />
    </header>
    <main class="w-full max-w-xl flex-grow overflow-auto px-4 pt-6 sm:mx-auto sm:min-h-[55dvh]">
      <slot>
        <Loading class="mx-auto mt-10 h-10 w-10" />
      </slot>
    </main>
    <footer class="w-full max-w-xl flex-shrink-0 sm:mx-auto">
      <ButtonPanel>
        <slot name="button-bar" />
      </ButtonPanel>
    </footer>
  </div>
</template>
